(() => {
  const CONFIG = {
    url: 'https://member.outlinespace.gr',        // <-- change to your URL
    label: 'Outliners',              // <-- change label
    openNew: true                  // true to open in new tab
  };

  function mountButton() {
    const container = document.querySelector('.header__column.header__column--right[data-testid="header-top-right"]');
    if (!container) return;

    // Avoid duplicates
    if (container.querySelector('#threeDbtnMount')) return;

    const wrap = document.createElement('span');
    wrap.className = 'header-actions__item header-actions__item--threeD';
    wrap.id = 'threeDbtnMount';

    const a = document.createElement('a');
    a.className = 'threeDbtn';
    a.href = CONFIG.url || '#';
    a.textContent = CONFIG.label || 'Shop Now';
    if (CONFIG.openNew) { a.target = '_blank'; a.rel = 'noopener'; }

    // tactile press via mouse/touch/keyboard
    a.setAttribute('role', 'button');
    a.addEventListener('keydown', e => { if (e.key === ' ' || e.key === 'Enter') a.classList.add('is-pressed'); });
    a.addEventListener('keyup',   () => a.classList.remove('is-pressed'));
    a.addEventListener('mousedown',() => a.classList.add('is-pressed'));
    a.addEventListener('mouseup',  () => a.classList.remove('is-pressed'));
    a.addEventListener('mouseleave',() => a.classList.remove('is-pressed'));
    a.addEventListener('touchstart',() => a.classList.add('is-pressed'), {passive:true});
    a.addEventListener('touchend',  () => a.classList.remove('is-pressed'), {passive:true});

    wrap.appendChild(a);
    container.appendChild(wrap);
  }

  // Run on load + when the header reloads in the theme editor
  document.addEventListener('DOMContentLoaded', mountButton);
  document.addEventListener('shopify:section:load', mountButton);
  document.addEventListener('shopify:section:select', mountButton);
})();
